import { FC, useCallback, useEffect, useMemo } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { PreventNavigation } from '~/hoc/prevent-navigation';
import { DataStore } from '~/store';
import { AccountDetail_ExperienceLegacy } from './experience-legacy';
import { useExperience } from '~/hooks/use-experience';
import { AccountDetail_ExperienceFunds } from './experience-funds';
import { AppLoader } from '~/components/app-loader';
import { APP_ROUTES } from '~/routes';

export const AccountDetail: FC = () => {
  /**
   * Store
   */
  const accountIds = DataStore.useStoreState(s => s.portfolio.accountIds);
  const isAuthenticated = DataStore.useStoreState(s => s.user.isAuthenticated);
  const accountDetail = DataStore.useStoreState(s => s.portfolio.accountDetail);

  const getAccountDetail = DataStore.useStoreActions(
    _ => _.portfolio.getAccountDetail
  );
  const setAccountDetail = DataStore.useStoreActions(
    _ => _.portfolio.setAccountDetail
  );

  /**
   * Hooks
   */
  const showFundsExperience = useExperience();
  const { id: accId } = useParams();
  useEffect(() => {
    (async () => {
      if (!isAuthenticated) {
        return;
      }
      if (!accId) {
        return;
      }
      await getAccountDetail({
        accountId: accId,
      });
    })();
  }, [accId]);
  useEffect(() => {
    return () => setAccountDetail(null);
  }, []);

  /**
   * Methods
   */
  const validate = useCallback(() => {
    return accId && accountIds.includes(accId);
  }, [accId, accountIds]);

  /**
   * DOM
   */
  const renderFundsAccountDetail = useMemo(() => {
    return showFundsExperience && accountDetail?.isAccountOfTypeFund;
  }, [showFundsExperience, accountDetail?.account?.accountType]);

  if (!accountDetail) {
    return (
      <div className="flex-1">
        <AppLoader isFixed spinnerTop="104px" />
      </div>
    );
  }

  /**
   * Note:
   * When launching account detail view we only ever want to land in a empty fund landing page,
   * for accounts that are truly new. If it has every had a pnl activity in the past we should land in the account detail
   */
  if (accountDetail.isNewFundAccount) {
    return (
      <Navigate
        to={
          APP_ROUTES.AUTH_PORTFOLIO_PRODUCT_SPLASH +
          `?type=${accountDetail.account?.accountType}`
        }
      />
    );
  }

  return (
    <PreventNavigation validate={validate}>
      {renderFundsAccountDetail ? (
        <AccountDetail_ExperienceFunds />
      ) : (
        <AccountDetail_ExperienceLegacy />
      )}
    </PreventNavigation>
  );
};
